const ORDER_SIZE_DICT = {
  30: 'Small',
  40: 'Medium',
  50: 'Large',
  60: 'Extra large',
};

export const CONSTANTS = {
  ORDER_SIZE_DICT,
};
